import { useNavigate } from 'react-router';
import type { RoleFormValues } from '../lib/rolePermissions';
import { useCreateRole, useUpdateRole } from './useAccessControlApi';

const ROLE_LIST_PATH = '/settings/role-management';

interface UseRoleSubmissionArgs {
  roleId: number | undefined;
  isEdit: boolean;
  values: RoleFormValues;
}

export interface RoleActions {
  submit: () => void;
  cancel: () => void;
  isSubmitting: boolean;
}

/** Owns the create-vs-update decision, the mutations, and navigation back to the list. */
export function useRoleSubmission({ roleId, isEdit, values }: UseRoleSubmissionArgs): RoleActions {
  const navigate = useNavigate();
  const createRole = useCreateRole();
  const updateRole = useUpdateRole();

  const submit = () => {
    const toList = { onSuccess: () => navigate(ROLE_LIST_PATH) };
    if (isEdit && roleId !== undefined) {
      updateRole.mutate({ id: roleId, data: values }, toList);
    } else {
      createRole.mutate(values, toList);
    }
  };

  return {
    submit,
    cancel: () => navigate(ROLE_LIST_PATH),
    isSubmitting: createRole.isPending || updateRole.isPending,
  };
}
